/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Text,
  View,
} from 'react-native';
import Autolink from 'react-native-autolink';

import Header from '../../components/misc/Header';
import styles from '../../styles';
import { translate } from '../../locales/i18n';

class Support extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Support';
  }

  render() {
    const { history } = this.props;

    const t = translate('company_support');
    const paragraphs = t.split('\n\n');

    return (
      <View style={styles.view.headed}>
        <Header
          name={translate('menu_support')}
          hasCancel
          history={history}
        />

        {paragraphs.map((paragraph) => (
          <Text style={[styles.common.paragraph, { textAlign: 'center' }]}>
            <Autolink text={paragraph} />
          </Text>
        ))}

        <Text style={[styles.common.paragraph, { textAlign: 'center' }]}>
          <a href="https://buy.stripe.com/fZe01UbID0DtbAYaEE">
            Turn your AI Agent into a dedicated website and/or mobile app
          </a>
        </Text>

        <Text style={[styles.common.paragraph, { textAlign: 'center' }]}>
          <a href="https://buy.stripe.com/bIY9Cu28371R9sQaEF">
            AI on Rails Consulting (basic)
          </a>
        </Text>

        <Text style={[styles.common.paragraph, { textAlign: 'center' }]}>
          <a href="https://buy.stripe.com/14kdSKdQL85VawUdQS">
            AI on Rails Consulting and Custom Solution Development (advanced)
          </a>
        </Text>
      </View>
    );
  }
}

Support.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default Support;
